module.exports = __webpack_public_path__ + "img/KEN_degradation-gully.662835e9.jpg";